import React, { useState } from "react";
// hooks
import { useWindowSize } from "src/hooks";
// components
import Checkbox from "src/components/ui/CheckboxNoWrapper/checkbox";
import { IScore } from "./index";
import {
  ContentWrapper,
  Title,
  RateWrapper,
  Score,
  ScoreLine,
  Percentage,
  AmountOfRates,
  RateLine,
  Label,
} from "./visitorRating.styles";

const TABLET = 768;

const VisitorRatingContainer = ({ setVisitorRating, reviewsStatistic, reviewsCount = 5 }: any) => {
  const size = useWindowSize();

  const scores = reviewsStatistic.rating
    .map((item: any, index: number) => {
      const decimal: number = (item.amountOfRates / reviewsCount) * 100;
      const percent = Number.isNaN(decimal)
        ? "0"
        : Number.parseFloat(decimal.toString()).toFixed(1);
      return {
        ...item,
        id: index,
        percents: `${percent}%`,
      };
    })
    .sort()
    .reverse();
  const [checkedState, setCheckedState] = useState(new Array(scores.length).fill(false));

  const handleOnChange = (position: any) => {
    // eslint-disable-next-line max-len
    const updatedCheckedState = checkedState.map((item: any, index: any) =>
      index === position ? !item : item,
    );

    setCheckedState(updatedCheckedState);
    setVisitorRating(updatedCheckedState);
  };

  return (
    <ContentWrapper>
      <Title>{size.width < TABLET ? "Visitor rating" : "Client ratings"}</Title>

      <RateWrapper>
        {scores.map((score: IScore, index: number) => {
          let styles =
            !+score.amountOfRates || (checkedState.some(Boolean) && !checkedState[index])
              ? { opacity: "0.5" }
              : {};
          return (
            <RateLine key={score.id} style={styles}>
              <Label>
                <Checkbox
                  value={checkedState[index]}
                  onChange={() => handleOnChange(index)}
                  disabled={!+score.amountOfRates}
                />
              </Label>
              <Score>{score.score}</Score>
              <ScoreLine percentage={score.percents} />
              <Percentage>{score.percents}</Percentage>
              <AmountOfRates>{score.amountOfRates}</AmountOfRates>
            </RateLine>
          );
        })}
      </RateWrapper>
    </ContentWrapper>
  );
};

export default VisitorRatingContainer;
